module.exports = __webpack_public_path__ + "img/phase2-sample-06.1e7001c4.jpg";